import React, {
	createContext,
	useContext,
	useState,
	useCallback,
	type ReactNode,
    useRef,
} from "react";
import {
	DndContext,
	useSensor,
	useSensors,
	type DragEndEvent,
	type DragStartEvent,
	type DragOverEvent,
    MouseSensor,
    DragOverlay,
    type DragMoveEvent,
    PointerSensor,
    pointerWithin,
    KeyboardSensor,
	closestCenter,
} from "@dnd-kit/core";
import type { Channel } from "@/utils/custom-types";
import { id } from "zod/v4/locales";
import type { Tab } from "./tabs-context";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

interface DndContextType {}

const DndProviderContext = createContext<DndContextType | undefined>(undefined);

export function DndProvider({
	children,
}: {
	children: ReactNode;
}) {
    const sensors = useSensors(
		useSensor(PointerSensor, {
			activationConstraint: {
				distance: 0,
			},
		}),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates,
		}),
	);

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={pointerWithin}
		>
			{children}
		</DndContext>
	);
}

export function useDndContext() {
	const context = useContext(DndProviderContext);
	if (context === undefined) {
		throw new Error(
			"useDndContext must be used within a DndContextProvider",
		);
	}
	return context;
} 